// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1RzIz","sendOtp":"AuthorizeToLogin_sendOtp__1Umb0"};